<template>
  <article
    :class="$style.userGroupItemSummary"
  >
    <h3 :class="$style.header">
      {{ itemSummary.title }}
    </h3>
    <p
      v-if="itemSummary.wasDataFetched && wasDataFetched"
      :class="[
        $style.resources,
        { [$style.noResources]: !areThereResources }]"
    >
      <template v-if="!areThereResources">
        {{ itemSummary.fallbackMessage }}
        <a
          :href="itemSummary.fallbackLinkUrl"
          :target="itemSummary.target"
        >
          {{ itemSummary.fallbackLinkText }}
        </a>
      </template>

      <slot v-else>
        {{ itemSummary.displayConfig.startWord }}
        <template v-for="item in itemSummary.items">
          <span
            :key="`${item}-resource`"
            :class="$style.resource"
          >{{ item }}</span>
          <span
            :key="`${item}-connector`"
            :class="$style.resourceConnector"
          >
            {{ itemSummary.displayConfig.itemsSeparators }}
          </span>
        </template>
      </slot>
    </p>
    <div
      v-else
      :class="[$style.loadingContainer]"
    >
      <LoadingIcon />
      <span> Loading </span>
    </div>
  </article>
</template>

<script>
import ItemSummary from 'client/components/ItemTable/BodyComponents/UserGroupSummary/ItemSummary';
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';

export default {
  name: 'UserGroupItemSummary',

  components: { LoadingIcon },

  props: {
    itemSummary: {
      type: ItemSummary,
      required: true,
    },

    wasDataFetched: {
      default: true,
      type: Boolean,
    },
  },

  computed: {
    areThereResources() {
      return this.itemSummary.areThereResources(this.itemSummary.items);
    },

    target() {
      return this.itemSummary.openLinkInNewTab ? '_blank' : '_self';
    },
  },
};
</script>

<style module>
@value ( jcWhite300, jcGrey200, jcTertiary ) from '~css/brand-colors.css';

.loadingContainer {
  align-items: center;
  display: flex;
}

.loadingContainer > svg {
  height: 18px;
}

.loadingContainer > span {
  font-size: 12px;
  margin-left: 3.5px;
}

.userGroupItemSummary {
  font-size: 0.923rem;
  line-height: 1.6;
}

.userGroupItemSummary > .header {
  font-size: 0.923rem;
  font-weight: bold;
  line-height: 1.6;
  margin: 0 0 5px;
}

.userGroupItemSummary[noMargin] > .header,
.userGroupItemSummary > .resources {
  margin: 0;
}

.userGroupItemSummary > .resources.noResources {
  font-style: italic;
}

.resource {
  background: jcWhite300;
  border: 1px solid jcGrey200;
  border-radius: 4px;
  box-sizing: border-box;
  color: jcTertiary;
  line-height: 3;
  padding: 5px;
  white-space: nowrap;
}

.resourceConnector:last-child {
  display: none;
}
</style>
